import { Link } from 'react-router-dom'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { AlertCircle, Info } from 'lucide-react'

// Custom components to use in MDX
export const mdxComponents = {
  // Custom link component that uses react-router for internal links
  a: ({ href, children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
    // Check if link is internal (starts with / or #)
    const isInternal = href?.startsWith('/') || href?.startsWith('#')

    if (isInternal && href?.startsWith('/docs')) {
      return (
        <Link to={href} {...props}>
          {children}
        </Link>
      )
    }

    // External links
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    )
  },

  // Code blocks — strip leading/trailing whitespace from code content
  pre: ({ children, ...props }: React.HTMLAttributes<HTMLPreElement>) => {
    return (
      <div className="relative group">
        <pre {...props} className={`${props.className || ''} [&>code]:before:content-none [&>code]:after:content-none`}>
          {children}
        </pre>
      </div>
    )
  },

  // Inline and block code — trim leading newlines
  code: ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => {
    let content = children
    if (typeof content === 'string') {
      content = content.replace(/^\n/, '')
    }
    return <code {...props}>{content}</code>
  },

  // Callout components
  Callout: ({ children, type = 'info' }: { children: React.ReactNode; type?: 'info' | 'warning' }) => {
    const Icon = type === 'warning' ? AlertCircle : Info
    const variant: React.ComponentProps<typeof Alert>['variant'] = type === 'warning' ? 'destructive' : 'default'

    return (
      <Alert variant={variant} className="my-4">
        <Icon className="h-4 w-4" />
        <AlertDescription>{children}</AlertDescription>
      </Alert>
    )
  },
}
